"use no memo";

import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/hooks/use-toast";
import { useZodResolver } from "@/lib/zod";
import { Turnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
import { useTranslations } from "next-intl";
import { useRef, useState, useTransition } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { sendMessage } from "../actions";
import { ContactSchema } from "../scheme";
const ContactForm = () => {
  const t = useTranslations("Home.sections.contactForm");
  const zodResolver = useZodResolver();
  const [isPending, startTransition] = useTransition();
  const [turnstileToken, setTurnstileToken] = useState<string | null>(null);
  const turnstileRef = useRef<TurnstileInstance | null>(null);
  const form = useForm<z.infer<typeof ContactSchema>>({
    resolver: zodResolver(ContactSchema),
    defaultValues: {
      name: "",
      email: "",
      message: ""
    }
  });
  function onSubmit(values: z.infer<typeof ContactSchema>) {
    if (!turnstileToken) return;
    startTransition(async () => {
      const [_, err] = await sendMessage({
        ...values,
        turnstileToken
      });
      if (err) {
        console.error(err);
        toast({
          title: t("messages.error.title"),
          description: t("messages.error.description"),
          variant: "destructive"
        });
      } else {
        form.reset();
        turnstileRef.current?.reset();
        setTurnstileToken(null);
        toast({
          title: t("messages.success.title"),
          description: t("messages.success.description")
        });
      }
    });
  }
  return <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField control={form.control} name="name" render={({
        field
      }) => <FormItem className="flex-1">
              <FormLabel>{t("fields.name.label")}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={form.control} name="email" render={({
        field: field_0
      }) => <FormItem className="flex-1">
              <FormLabel>{t("fields.email.label")}</FormLabel>
              <FormControl>
                <Input {...field_0} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={form.control} name="message" render={({
        field: field_1
      }) => <FormItem className="flex-1">
              <FormLabel>{t("fields.message.label")}</FormLabel>
              <FormControl>
                <Textarea {...field_1} placeholder={t("fields.message.placeholder")} rows={4} className="resize-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <Turnstile ref={turnstileRef} siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY!} onSuccess={setTurnstileToken} onExpire={() => setTurnstileToken(null)} options={{
        theme: "dark",
        size: "flexible"
      }} />
        <div className="flex items-center justify-end">
          <Button loading={isPending} disabled={!turnstileToken}>
            {t("buttons.submit")}
          </Button>
        </div>
      </form>
    </Form>;
};
export default ContactForm;